import { Dropdown } from "antd";
import { useContext, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { Link } from "react-router-dom";
import { store } from "../../Helper/Context/Store";
import "./MainNavabar.css";
export default function MainNavabarMenu() {
  const { siteHeader } = useContext(store);
  const [navItems, setNavItems] = useState([]);
  const [megaMenu, setMegaMenu] = useState(null);
  // const [show, setShow] = useState(false);
  // const showDropdown = (e) => {
  //   setShow(!show);
  // };
  // const hideDropdown = (e) => {
  //   setShow(false);
  // };
  // useEffect(() => {
  //   const navbarData = siteHeader;
  //   setNavItems(navbarData)
  // }, [navItems])


  const dropdowns = siteHeader.map((item, index) => {
    const items = item.subcategories?.map((child) => ({
      key: child.id,
      label: (
        <Link to={`/${child.path1}`} className="dropdown-link mx-2">
          {child.label1}
        </Link>
      ),
      children: child.subcat?.map((sub) => ({
        key: sub.id,
        label: (
          <Link to={`/${sub.path1}`} className="dropdown-link mx-2">
            {sub.label1}
          </Link>
        ),
      })),
    }));
    return (
      <Dropdown
        className="main-dropdown"
        key={index}
        menu={{
          items,
        }}
        onMouseEnter={() => setMegaMenu(null)}>
        <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
          {item.label} <IoIosArrowDown />
        </a>
      </Dropdown>
    );
  });

  return (
    <div
      // className="border-top border-bottom"
      onMouseLeave={() => setMegaMenu(null)}>
      {/* <div className="container-fluid d-none d-lg-block">
        <div className="row"> */}
      <div className="col-12">
        <ul className="d-flex gap-lg-3 main-nav-menu-links px-0 py-2 justify-content-center">
          {/* <li>
                <Link to="/">Our Story</Link>
              </li> */}
          {/* {siteHeader.length > 0 ? siteHeader?.map((data, index) => { */}
          {/* {siteHeader ? siteHeader?.map((data, index) => {
                return (
                  <li key={`main-header${index}`}>
                    <NavDropdown
                      title={data.label}
                      id={data.id}
                      renderMenuOnMount={true}>
                      {data.subcategories?.map((subcat, ind) => {
                        return (
                          <NavDropdown.Item
                            key={`subcat-${ind}`}
                            as={Link} // Use Link as the 'as' prop
                            to={`/ct${subcat.path}`}
                            className="w-100"
                          >
                            {subcat.label1}
                          </NavDropdown.Item>
                        )
                      })}
                    </NavDropdown>
                  </li>
                )
              }) : ""} */}
          {/* {dropdowns} */}

          <div className="mega-menu">
            {siteHeader.map((category, index) => (
              <div
                key={index}
                className="menu-item"
                onMouseEnter={() => setMegaMenu(index)}
                onMouseLeave={() => setMegaMenu(null)}>
                <span className="menu-title">
                  {category.label} <IoIosArrowDown />
                </span>
              </div>
            ))}
          </div>
          {/* Desktop Mega Dropdown with Submenus */}
          {siteHeader.map((category, index) => (
            <div
              key={index}
              className={`mega-dropdown ${megaMenu === index ? "active" : ""
                }`}
              onMouseEnter={() => setMegaMenu(index)}
              onMouseLeave={() => setMegaMenu(null)}>
              <div className="row">
                <div className="col-lg-3">
                  <img
                    src={category?.image}
                    className="img-fluid"
                    alt="Category"
                  />
                </div>
                <div className="col-lg-9 d-flex gap-2">
                  {category.subcategories?.filter((submenu) => submenu?.fld_showOnWebsite === "InActive")?.map((submenu, subIndex) => (
                    <div key={subIndex} className="submenu">
                      <h5 className="border-bottom pb-2 mb-0 w-100">
                        {submenu.label1}
                      </h5>
                      <div className="submenu-items">
                        {submenu?.subcat?.map((item, idx) => (
                          <div key={idx} className="dropdown-item">
                            <a href={item?.path}>
                              {item.label1}
                              {item.badge && (
                                <span
                                  className={
                                    item.badge == "New"
                                      ? "new"
                                      : "" || item.badge == "Offer"
                                        ? "offer"
                                        : "" || item.badge == "Bestseller"
                                          ? "bestseller"
                                          : "" || item.badge == "Discount"
                                            ? "discount"
                                            : ""
                                  }>
                                  {item.badge}
                                </span>
                              )}
                            </a>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          {/* <li>
                <NavDropdown
                  title="Handcrafted Jewellery"
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}>
                  <NavDropdown.Item>one</NavDropdown.Item>
                </NavDropdown>
              </li>
              <li>
                <NavDropdown
                  title="Semi Precious Jewellery"
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}>
                  <NavDropdown.Item>one</NavDropdown.Item>
                </NavDropdown>
              </li>
              <li>
                <NavDropdown
                  title="Temple Jewellery"
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}>
                  <NavDropdown.Item>one</NavDropdown.Item>
                </NavDropdown>
              </li>
              <li>
                <NavDropdown
                  title="Healing Jewellery"
                  id="offcanvasNavbarDropdown-expand-sm"
                  renderMenuOnMount={true}>
                  <NavDropdown.Item>one</NavDropdown.Item>
                </NavDropdown>
              </li> */}
          {/* <li>
                <Link to="/">Gifting Ideas</Link>
              </li>
              <li>
                <Link to="/">Festive Collection</Link>
              </li> */}
        </ul>
      </div>
      {/* </div>
      </div> */}
    </div>
  );
}
